﻿import './tracker.config';

import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basics/tk.manager';
import DIWButtonDropdown from '@/controls/diw.button.dropdown';
import TKNavigationSidebar from '@tk/components/tk.navigation.sidebar';
import TKHeader from '@tk/components/tk.header';
import DIWViewport from '@/basics/diw.viewport';
import DIWSearch from '@/controls/diw.search';
import DIWCarousel from '@/components/diw.carousel';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKFlag from '@tk/components/tk.flag';
import TKProductTile from '@tk/components/tk.product.tile';
import TKProductVariants from '@tk/components/tk.product.variants';
import TKTooltip from '@tk/components/tk.tooltip';
import DIWDialog from '@/components/diw.dialog';
import TKPrice from '@tk/components/tk.price';
import TKStaticContent from '@tk/controls/tk.static.content';
import TKTabsTab from '@tk/controls/tk.tabs.tab';
import TKArticleList from '@tk/components/tk.article.list';
import TKFavoriteButton from '@tk/components/tk.favorite.button';
import TKFavoriteInfo from '@tk/components/tk.favorite.info';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@/controls/diw.form.validator';
import TKAssetGallery from '@tk/components/tk.asset.gallery';
import TKTabsAccordion from '@tk/controls/tk.tabs.accordion';
import TKSelection from '@tk/controls/tk.selection';
import TKArtSpecTable from '@tk/components/tk.art.spec.table';
import TKShowMore from '@tk/components/tk.show.more';
import TKSelectRedirect from '@tk/controls/tk.select.redirect';
import TKPopup from '@tk/components/tk.popup';
import TKArticleListSort from '@tk/components/tk.article.list.sort';
import TKArticleListLayoutSwitch from '@tk/components/tk.article.list.layout.switch';
import TKBreadcrumb from '@tk/components/tk.breadcrumb';
import TKCompareButton from '@tk/components/compare/tk.compare.button';
import TKCompareStore from '@tk/components/compare/tk.compare.store';
import TKCompareInfo from '@tk/components/compare/tk.compare.info';
import TKStatusConsole from '@tk/components/tk.status.console';
import TKClipboard from '@tk/components/tk.clipboard';
import TKRequestManager from '@tk/basics/tk.request.manager';
import TKTracker from '@tk/components/tracker/tk.tracker';
import TKTracking from '@tk/components/tracker/tk.tracking';
import TKTable from '@tk/components/tk.table';
import { configureStore } from '@tk/utilities/tk.use.store';
import DIWMinibasket from '@/components/diw.minibasket';
import DIWRadio from '@/components/diw.radio';
import DIWSelectRedirect from '@/components/diw.select.redirect';
import DIWStock from '@/components/diw.stock';
import DIWPrice from '@/components/diw.price';
import DIWBasketButton from '@/components/diw.basket.button';
import DIWGiftcard from '@/components/diw.giftcard';
import DIWPriceControl from '@/components/diw.price.control';
import DIWLinks from '@/components/diw.links';
import DIWPersonalise from '@/components/diw.personalisation.element';
import DIWPersonaliseContainer from '@/components/diw.personalise.container';

import 'tippy.js/dist/tippy.css';
import '@scss/modules/article.scss';

const compareStore = new TKCompareStore();

configureStore({
    compareStore,
});

export default class Article extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'tk-request-manager', constructor: TKRequestManager },
            { name: 'tk-viewport', constructor: DIWViewport },
            { name: 'tk-tracker', constructor: TKTracker },
            { name: 'tk-status-console', constructor: TKStatusConsole },
            { name: 'tk-clipboard', constructor: TKClipboard },
            { name: 'tk-button-dropdown', constructor: DIWButtonDropdown },
            { name: 'tk-header', constructor: TKHeader },
            { name: 'tk-nav-sidebar', constructor: TKNavigationSidebar },
            { name: 'diw-search', constructor: DIWSearch },
            { name: 'tk-carousel', constructor: DIWCarousel },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-flag', constructor: TKFlag },
            { name: 'tk-product-tile', constructor: TKProductTile },
            { name: 'tk-product-variants', constructor: TKProductVariants },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'tk-dialog', constructor: DIWDialog },
            { name: 'tk-article-list', constructor: TKArticleList },
            { name: 'tk-price', constructor: TKPrice },
            { name: 'tk-static-content', constructor: TKStaticContent },
            { name: 'tk-tabs-tab', constructor: TKTabsTab },
            { name: 'tk-tabs-accordion', constructor: TKTabsAccordion },
            { name: 'tk-favorite-button', constructor: TKFavoriteButton },
            { name: 'tk-favorite-info', constructor: TKFavoriteInfo },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-asset-gallery', constructor: TKAssetGallery },
            { name: 'tk-selection', constructor: TKSelection },
            { name: 'tk-art-spec-table', constructor: TKArtSpecTable },
            { name: 'tk-show-more', constructor: TKShowMore },
            { name: 'tk-select-redirect', constructor: TKSelectRedirect },
            { name: 'tk-popup', constructor: TKPopup },
            { name: 'tk-article-list-sort', constructor: TKArticleListSort },
            { name: 'tk-article-list-layout-switch', constructor: TKArticleListLayoutSwitch },
            { name: 'tk-breadcrumb', constructor: TKBreadcrumb },
            { name: 'tk-compare-button', constructor: TKCompareButton },
            { name: 'tk-compare-info', constructor: TKCompareInfo },
            { name: 'tk-tracking', constructor: TKTracking },
            { name: 'tk-basket-button', constructor: DIWBasketButton },
            { name: 'diw-price', constructor: DIWPrice },
            { name: 'tk-table', constructor: TKTable },
            { name: 'diw-minibasket', constructor: DIWMinibasket },
            { name: 'diw-radio', constructor: DIWRadio },
            { name: 'diw-select-redirect', constructor: DIWSelectRedirect },
            { name: 'diw-stock', constructor: DIWStock },
            { name: 'diw-giftcard', constructor: DIWGiftcard },
            { name: 'diw-price-control', constructor: DIWPriceControl },
            { name: 'diw-links', constructor: DIWLinks },
            { name: 'diw-personalise', constructor: DIWPersonalise },
            { name: 'diw-personalise-container', constructor: DIWPersonaliseContainer },
        ]);
    }
}

new Article();
